import styled, { keyframes } from 'styled-components';

import { manageColor } from '@pb/styles';
import {
    TStyledChildProperties,
    TStyledSpinnerProperties,
} from './spinner.types';

function rotationDegrees(circleNumber: number): number {
    return (circleNumber - 1) * 30;
}

function animationDelay(circleNumber: number): number {
    return (12 + circleNumber - 1) / 15;
}

const circleBounceDelay = keyframes`
    0%,
    80%,
    100% {
        transform: scale(0);
    }

    40% {
        transform: scale(1);
    }
`;

export const StyledSpinner = styled.div<TStyledSpinnerProperties>`
    position: relative;
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    margin: auto;
`;

export const StyledChild = styled.div<TStyledChildProperties>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: rotate(${({ number }) => rotationDegrees(number)}deg);

    &::before {
        display: block;
        width: 15%;
        height: 15%;
        margin: 0 auto;
        background-color: ${({ spinnerColor, theme }) =>
            manageColor({ color: spinnerColor, theme })};
        border-radius: 100%;
        animation: ${circleBounceDelay} 0.9s infinite ease-in-out both;
        animation-delay: ${({ number }) => animationDelay(number)}s;
        content: '';
    }
`;
